import React from 'react';
import { breakpoints, CancelIcon } from '@chegg-ui/theme';
import { createPortal } from 'react-dom';
import { useModalBehavior } from '../externals';
import { FullsizeContainer, ModalCenteringContainer, StyledModal, Title, Content, TopRightIconButton, ButtonAnimationContainer, ModalButtons, ModalPadding } from '../styles';

var Modal = function Modal(_ref) {
  var id = _ref.id,
      children = _ref.children,
      className = _ref.className,
      dataTest = _ref['data-test'],
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      title = _ref.title,
      ariaLabel = _ref['aria-label'],
      ariaDescribedby = _ref['aria-describedby'],
      _ref$hideCloseButton = _ref.hideCloseButton,
      hideCloseButton = _ref$hideCloseButton === void 0 ? false : _ref$hideCloseButton,
      _ref$shouldCloseOnCli = _ref.shouldCloseOnClickOutside,
      shouldCloseOnClickOutside = _ref$shouldCloseOnCli === void 0 ? true : _ref$shouldCloseOnCli,
      _ref$hideBackgroundOv = _ref.hideBackgroundOverlay,
      hideBackgroundOverlay = _ref$hideBackgroundOv === void 0 ? false : _ref$hideBackgroundOv,
      notifBanner = _ref.notifBanner,
      primaryActionButton = _ref.primaryActionButton,
      secondaryActionButton = _ref.secondaryActionButton,
      _ref$buttonAlignment = _ref.buttonAlignment,
      buttonAlignment = _ref$buttonAlignment === void 0 ? 'horizontal' : _ref$buttonAlignment,
      selector = _ref.selector;

  var _useModalBehavior = useModalBehavior({
    isOpen: isOpen,
    onClose: onClose,
    id: id,
    selector: selector
  }),
      closing = _useModalBehavior.closing,
      onModalKeyDown = _useModalBehavior.onModalKeyDown,
      modalRef = _useModalBehavior.modalRef;

  var isMobileScreen = typeof window !== 'undefined' && window.matchMedia && window.matchMedia("(max-width: ".concat(breakpoints.sm.max, ")")).matches;
  var modalContent = /*#__PURE__*/React.createElement(FullsizeContainer, {
    onClick: shouldCloseOnClickOutside ? onClose : undefined,
    className: className,
    closing: closing,
    "data-test": "".concat(dataTest ? dataTest : id, "-container"),
    hideBackgroundOverlay: hideBackgroundOverlay // consistent naming needed across modals/dialogs to avoid making this element inert, see:
    // https://www.w3.org/TR/wai-aria-practices-1.1/examples/dialog-modal/dialog.html
    ,
    id: "".concat(id, "-container")
  }, /*#__PURE__*/React.createElement(ModalCenteringContainer, {
    closing: closing
  }, /*#__PURE__*/React.createElement(StyledModal, {
    id: id,
    ref: modalRef,
    role: "dialog",
    "aria-modal": "true" // aria-label is needed only when there's no title, aria-labelledby needed only when there is
    ,
    "aria-label": title ? undefined : ariaLabel,
    "aria-labelledby": title ? "".concat(dataTest ? dataTest : id, "-title") : undefined,
    "aria-describedby": ariaDescribedby,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onKeyDown: onModalKeyDown,
    "data-test": dataTest ? dataTest : id,
    hasCloseButton: !hideCloseButton
  }, /*#__PURE__*/React.createElement(ModalPadding, null, title && /*#__PURE__*/React.createElement(Title, {
    closing: closing,
    id: "".concat(dataTest ? dataTest : id, "-title")
  }, title), /*#__PURE__*/React.createElement(Content, {
    closing: closing
  }, children), !primaryActionButton ? undefined : /*#__PURE__*/React.createElement(ButtonAnimationContainer, {
    closing: closing
  }, /*#__PURE__*/React.createElement(ModalButtons, {
    alignment: buttonAlignment
  }, /*#__PURE__*/React.cloneElement(primaryActionButton, {
    size: isMobileScreen ? 'small' : 'medium'
  }), secondaryActionButton ? /*#__PURE__*/React.cloneElement(secondaryActionButton, {
    size: isMobileScreen ? 'small' : 'medium'
  }) : null)), !hideCloseButton && /*#__PURE__*/React.createElement(TopRightIconButton, {
    onClick: onClose,
    screenReaderOnlyText: "close dialog",
    size: isMobileScreen ? 'small' : 'medium'
  }, /*#__PURE__*/React.createElement(CancelIcon, {
    id: "modalCloseIcon"
  }))), notifBanner)));

  if (!isOpen && !closing) {
    return null;
  }

  return /*#__PURE__*/createPortal(modalContent, selector && document.querySelector(selector) || document.body);
};

Modal.displayName = 'Modal';
export default Modal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/modal/dist/esm/variants/Modal.js
// module id = 4041
// module chunks = 11